<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>积分排行</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-row>


				<el-form :inline="true" class="user-search" :model="formInline" label-width="120">
					<el-form-item label="用户名称：">
						<el-input size="small" placeholder="请输入用户名称" v-model="formInline.userName" clearable 	 >
						</el-input>
					</el-form-item>
					<el-form-item label="周期">
						<el-select v-model="formInline.rankType" placeholder="请选择" 	size="small"  clearable>
							<el-option label="周" value="week"></el-option>
							<el-option label="月" value="month"></el-option>
							<el-option label="年" value="year"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="奖品期数">
						<!-- <el-input v-model="formInline.weekSort"></el-input> -->
						<el-input v-model='formInline.weekSort' oninput="value=value.replace(/[^\d]/g,'')" maxLength='9'
						size="small" style="width: 150px;" />

					</el-form-item>
					<el-form-item>
						<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</el-form-item>
					<el-form-item>
						<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
					</el-form-item>
					<!-- <el-form-item>
						<el-button size="small" type="danger" icon="el-icon-plus" @click="exportPoint">导出获奖名单
						</el-button>
					</el-form-item> -->
				</el-form>
			</el-row>
		</el-card>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="index" label="排名" align="center"></el-table-column>
			<el-table-column prop="userName" label="用户名称" align="center"> </el-table-column>

			<el-table-column prop="mobile" label="手机号码" align="center">
			</el-table-column>
			<el-table-column prop="pointAmount" label="积分" align="center">

			</el-table-column>
			<el-table-column label="开始时间" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.startTime,'Y-M-D h:m')}}
				</template>
			</el-table-column>
			<el-table-column label="结束时间" align="center">
				<template slot-scope="scope">
					{{web.formatTime(scope.row.endTime,'Y-M-D h:m')}}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button v-if="scope.row.isReal == 'false'" size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
					<el-button v-if="scope.row.isReal == 'false'" size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 弹框 设代理和设置会员-->
		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible" width="500px">
			<el-form label-width="120px" :model="editForm" ref="brandForm" :rules="rules">
				<!-- businessUserList -->
				<el-form-item label="用户姓名:" prop="uid">
					<el-select v-model="editForm.uid" placeholder="请选择" style="width: 150px;" clearable>
						<el-option :label="item.username" :value="item.uid" v-for="(item,index) in businessUserList"
							:key="index"></el-option>

					</el-select>
				</el-form-item>
				<el-form-item label="积分:" prop="pointAmount">
					<el-input v-model="editForm.pointAmount" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="添加时间：" prop="happenTime">
					<datatime v-model="editForm.happenTime" catename="happenTime"></datatime>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitedit('brandForm')">提交</el-button>

			</span>

		</el-dialog>


	</div>
</template>

<script>
	import {
		delPoint,
		addFalsePoint,
		getAllUserRanks,
		addFictitiousPoint,
		getBusinessUser,
		// getRewardGoodsExport
	} from '../../api/basisMG.js'
	// import uploadwgt from '@/components/uploadwgt'
	// 导出模块
	export default {
		components: {
			// uploadwgt,
		},

		// 模块数据
		data() {
			//数据  
			return {
				rules: {
					uid: [{
						required: true,
						message: '请选择用户',
						trigger: 'change'
					}],
					pointAmount: [{
						required: true,
						message: '请填写积分',
						trigger: 'blur'
					}],
					happenTime: [{
						required: true,
						message: '请选择时间',
						trigger: 'change'
					}]
				},
				weekSort: '',
				rankType: 'week',
				cycleTime: "",
				goodsImg: '',
				loading: true,
				visible: false,
				listData: [],
				dialogVisible: false,
				formInline: {
					start: 0,
					length: 10,
					rankType: 'week',
					weekSort: 1

				},
				editForm: {},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10,
					start: 0,
					length: 10
				},
				businessUserList: []
			}
		},


		watch: {},

		methods: {
			// exportPoint() {
			// 	getRewardGoodsExport()
			// },
			search() {
				this.getdata()
			},
			getAllBusinessUser() {
				getBusinessUser().then(res => {
					console.log(res)
					this.businessUserList = res.data
				})
			},
			uploadone(data) {
				this.editForm.goodsImg = data
			},
			handleUpload(url) {
				// this.editForm.wgtUrl = url
				this.$set(this.editForm, 'wgtUrl', url)
				console.log(this.editForm.wgtUrl)
			},
			handleUpload1(url) {
				this.$set(this.editForm, 'pkgUrl', url)
				// this.editForm.pkgUrl = url
				console.log(this.editForm.wgtUrl1)
			},
			handleadd() {
				this.dialogVisible = true
				this.editForm = {}

			},
			handleedit(row) {
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
			handledelete(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delPoint({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}

					})
				})

			},
			submitedit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let param = this.editForm
						this.$confirm('确认提交吗', '提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							addFictitiousPoint(param).then(res => {
								console.log(res)
								if (res.code == '200') {
									this.$message({
										message: '提交成功',
										type: 'success'
									})
									this.dialogVisible = false
									this.getdata()
								}

							})
						})
					}
				})
			},
			submitedit1() {
				let param = this.editForm
				// param.upgradeId = this.editForm.id
				this.$confirm('确认提交吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					addFalsePoint(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.dialogVisible = false
							this.getdata()
						}

					})

				})

			},
			getdata() {
				let params = this.formInline
				// params.weekSort = this.weekSort
				// params.rankType = this.rankType
				getAllUserRanks(params).then(res => {
					console.log('params111',params)
				
					this.saveParams(this.$route.path,params)
					if (res.code == 200) {
						this.listData = res.data
						this.loading = false

					}
				})
			},

		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			console.log('formInline',this.formInline)
			// if(this.formInline.weekSort){
			// 	this.weekSort = this.formInline.weekSort
			
			// }
			// if(this.formInline.rankType){
			
			// 	this.weekSort = this.formInline.rankType
			// }
		
			this.getAllBusinessUser()
			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
